<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="cards"
	[loading]="!cards"
	[globalFilterFields]="app.keys(cards)"
	[rows]="10"
	[paginator]="true"
	[showCurrentPageReport]="true"
	responsiveLayout="scroll"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
	[rowsPerPageOptions]="[10, 25, 50]"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="flex-grow-1">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search...</label>
				</span>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="AcctNo">
				<div class="d-flex w-100">
					Account Number
					<p-sortIcon field="AcctNo"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="text" field="AcctNo" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="issued">
				<div class="d-flex w-100">
					Activated
					<p-sortIcon field="issued"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="boolean" field="issued" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
			<th pSortableColumn="created">
				<div class="d-flex w-100">
					Created on
					<p-sortIcon field="created"></p-sortIcon>
					<div class="ms-auto">
						<p-columnFilter type="date" field="created" display="menu" class="ms-auto"></p-columnFilter>
					</div>
				</div>
			</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="cardSelected = rec">
			<td>{{ rec.AcctNo }}</td>
			<td>
				<fa-icon [icon]="['far', 'check-double']" *ngIf="rec.Issued"></fa-icon>
			</td>
			<td>
				<span *ngIf="rec.created">
					{{ app.moment(rec.created).format("L LT") }}
				</span>
			</td>
		</tr>
	</ng-template>
</p-table>
<app-gift-card-record *ngIf="cardSelected" [(cardSelected)]="cardSelected"></app-gift-card-record>
